import styled from 'styled-components';

export const Container = styled.div`
	position: relative;
	display: inline-block;
`;

export const InputButton = styled.button`
	width: 12rem;
	height: 3rem;
	border: 1px solid #ddd;
	border-radius: 0.5rem;
	background-color: #fff;
	padding: 0 1rem;
	font-size: 1.4rem;
	font-family: 'NotoSansKR-Regular', sans-serif;
	color: #333;
	cursor: pointer;
	text-align: left;
	display: flex;
	align-items: center;

	&:focus {
		outline: none;
		border-color: #ddd;
	}

	&:hover {
		border-color: #bbb;
	}
`;

export const Calendar = styled.div`
	position: absolute;
	top: 100%;
	left: 0;
	background: white;
	border: 1px solid #ddd;
	border-radius: 0.5rem;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	z-index: 1000;
	margin-top: 0.25rem;
	min-width: 20rem;
`;

export const CalendarHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1rem;
	border-bottom: 1px solid #eee;
`;

export const NavButton = styled.button`
	width: 2rem;
	height: 2rem;
	border: none;
	background: none;
	font-size: 1.5rem;
	cursor: pointer;
	color: #666;
	display: flex;
	align-items: center;
	justify-content: center;

	&:hover {
		color: #333;
		background-color: #f5f5f5;
		border-radius: 50%;
	}
`;

export const MonthYear = styled.div`
	font-size: 1.5rem;
	font-weight: 600;
	color: #333;
	font-family: 'NotoSansKR-Bold', sans-serif;
`;

export const CalendarBody = styled.div`
	padding: 1rem;
`;

export const DayNames = styled.div`
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	gap: 0.25rem;
	margin-bottom: 0.5rem;
`;

export const DayName = styled.div`
	text-align: center;
	font-size: 1.1rem;
	font-weight: 600;
	color: #666;
	padding: 0.5rem 0;
	font-family: 'NotoSansKR-Bold', sans-serif;
`;

export const DaysGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	gap: 0.25rem;
`;

export const Day = styled.button`
	width: 2.5rem;
	height: 2.5rem;
	border: none;
	background: none;
	cursor: pointer;
	font-size: 1.2rem;
	color: #333;
	border-radius: 0.25rem;
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: 'NotoSansKR-Regular', sans-serif;

	&:hover {
		background-color: #f0f0f0;
	}

	${({ isSelected }) =>
		isSelected &&
		`
		background-color: #007bff;
		color: white;
		
		&:hover {
			background-color: #0056b3;
		}
	`}
`;

export const EmptyDay = styled.div`
	width: 2.5rem;
	height: 2.5rem;
`;
